import { dateTransform } from "helpers/dataHelpers";
import { TABLE_DATE } from "consts";
import {
  FilterField,
  FilterFieldDropdownOption,
  FilterOption,
} from "types/tableFilters";

import {
  ReportsFilterNames,
  ReportsFilterTypes,
  ReportStatus,
  ReportStatusLabel,
  ReportType,
  ReportTypeLabel,
} from "types/reports";

export const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    sorter: true,
  },
  {
    title: "Records",
    dataIndex: "totalRecords",
    key: "totalRecords",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: true,
  },
  {
    title: "Created at",
    dataIndex: "createdAt",
    key: "createdAt",
    sorter: true,
    width: 180,
    render: (date: string) =>
      dateTransform({
        date,
        format: TABLE_DATE,
      }),
  },
  {
    title: "Completed at",
    dataIndex: "completedAt",
    key: "completedAt",
    sorter: true,
    width: 180,
    render: (date: string) =>
      dateTransform({
        date,
        format: TABLE_DATE,
      }),
  },
];

export const reportTypeDropdownFields: FilterFieldDropdownOption[] = [
  {
    type: ReportType.ORDERS,
    label: ReportTypeLabel[ReportType.ORDERS],
  },
  {
    type: ReportType.TRANSACTIONS,
    label: ReportTypeLabel[ReportType.TRANSACTIONS],
  },
  {
    type: ReportType.CUSTOMERS,
    label: ReportTypeLabel[ReportType.CUSTOMERS],
  },
];

export const reportStatusDropdownFields: FilterFieldDropdownOption[] = [
  {
    type: ReportStatus.PENDING,
    label: ReportStatusLabel[ReportStatus.PENDING],
  },
  {
    type: ReportStatus.IN_PROGRESS,
    label: ReportStatusLabel[ReportStatus.IN_PROGRESS],
  },
  {
    type: ReportStatus.COMPLETED,
    label: ReportStatusLabel[ReportStatus.COMPLETED],
  },
  {
    type: ReportStatus.FAILED,
    label: ReportStatusLabel[ReportStatus.FAILED],
  },
];

export const filtersList: FilterOption[] = [
  {
    key: ReportsFilterTypes.type,
    label: ReportsFilterNames[ReportsFilterTypes.type],
    field: FilterField.SELECT,
    options: reportTypeDropdownFields,
  },
  {
    key: ReportsFilterTypes.status,
    label: ReportsFilterNames[ReportsFilterTypes.status],
    field: FilterField.SELECT,
    options: reportStatusDropdownFields,
  },
];
